import PhoneForwardedIcon from '@mui/icons-material/PhoneForwarded'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import React, { useCallback, useState } from 'react'

import T from 'T'
import { Z_INDEX } from 'theme/zIndex'
import { handleErrorWithMessage } from 'utils/error'

import DemoCallerItem from './DemoCallerItem'
import { DemoCaller, getDemoCallers, simulateCall } from './screenPopApi'

interface DemoCallMenuProps {
  businessId: string
}

const DemoCallMenu = ({ businessId }: DemoCallMenuProps) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)
  const [callers, setCallers] = useState<DemoCaller[]>([])

  const handleOpen = useCallback(
    async (event: React.MouseEvent<HTMLElement>) => {
      setAnchor(event.currentTarget)
      try {
        setCallers(await getDemoCallers(businessId))
      } catch (error) {
        handleErrorWithMessage(error, T.SCREEN_POP_DEMO_CALL_FAILED)
      }
    },
    [businessId]
  )

  const handleClose = useCallback(() => setAnchor(null), [])

  const handleCall = useCallback(
    async (caller: DemoCaller) => {
      setAnchor(null)
      try {
        await simulateCall(businessId, caller)
      } catch (error) {
        handleErrorWithMessage(error, T.SCREEN_POP_DEMO_CALL_FAILED)
      }
    },
    [businessId]
  )

  return (
    <>
      <Button
        size="small"
        startIcon={<PhoneForwardedIcon />}
        sx={{ position: 'fixed', left: 16, bottom: 16, zIndex: Z_INDEX.ABOVE_DRAWER }}
        variant="contained"
        onClick={handleOpen}
      >
        {T.SCREEN_POP_DEMO_CALL}
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={handleClose}>
        {callers.map(caller => (
          <DemoCallerItem key={caller.fromNumber} caller={caller} onCall={handleCall} />
        ))}
      </Menu>
    </>
  )
}

export default DemoCallMenu
